import http from 'plugins/axios';

export default {
  getUserOrderLogList(data) {
    return http.get({
      url: '/ta/admin/tenant/user/userOrderLog',
      data,
    });
  },
  exportUserOrderLog(data) {
    return http.get({
      url: '/ta/admin/tenant/user/userOrderLog/export',
      data,
      responseType: 'blob',
    });
  },
};
